import { render, staticRenderFns } from "./RoundHistoryView.vue?vue&type=template&id=5442f2f6&scoped=true"
import script from "./RoundHistoryView.vue?vue&type=script&lang=js"
export * from "./RoundHistoryView.vue?vue&type=script&lang=js"
import style0 from "./RoundHistoryView.vue?vue&type=style&index=0&id=5442f2f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442f2f6",
  null
  
)

export default component.exports